<script>
import baseMixin from '@/mixins/baseMixin'
import CommentModel from '@/models/comments/commentModel'
import CommentBase from './comment-base.vue'

export default {
  name: 'CommentDefault',
  components: { CommentBase },
  mixins: [baseMixin],
  props: {
    comment: {
      type: CommentModel,
      required: true,
    },
  },
  computed: {
    formattedCommentText() {
      const text = this.comment.commentText

      function formatHeading(heading) {
        return heading
          .replace(/([A-Z])/g, ' $1')
          .replace(/^./, (str) => str.toUpperCase())
          .trim()
      }

      try {
        let commentObjects = JSON.parse(text)
        commentObjects = Array.isArray(commentObjects)
          ? commentObjects
          : [commentObjects]
        let commentText = ''
        commentObjects.forEach((obj, index) => {
          if (index > 0) {
            commentText += '/n'
          }
          Object.keys(obj).forEach((key) => {
            const heading = formatHeading(key)
            commentText += `${heading}: ${obj[key]}\n`
          })
        })

        return commentText.trim()
      } catch (e) {
        return text
      }
    },
  },
}
</script>

<template>
  <CommentBase
    :added-by="comment.addedBy"
    :text="formattedCommentText"
    :subtitle="comment.getDateCreatedTimestamp()"
    :type="comment.type"
  />
</template>
